function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "cuz305jbda",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.193 24.905a7.436 7.436 0 0 0 14.74-1.408V8.624a7.436 7.436 0 0 0-14.74-1.408 7.436 7.436 0 0 0-14.74 1.408v14.873a7.436 7.436 0 0 0 14.74 1.408z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.193 24.905a7.436 7.436 0 0 0 14.74-1.408V8.624a7.436 7.436 0 0 0-14.74-1.408 7.436 7.436 0 0 0-14.74 1.408v14.873a7.436 7.436 0 0 0 14.74 1.408z",
  fill: "#4E5EFA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m16.193 24.905-.982-.188h1.964l-.982.188zm0-17.69.982.189h-1.964l.982-.188zm7.303 24.718a8.439 8.439 0 0 1-8.285-6.84l1.964-.376a6.439 6.439 0 0 0 6.321 5.216v2zm8.437-8.436a8.436 8.436 0 0 1-8.437 8.436v-2a6.436 6.436 0 0 0 6.437-6.436h2zm0-14.873v14.873h-2V8.624h2zM23.496.188a8.436 8.436 0 0 1 8.437 8.436h-2a6.436 6.436 0 0 0-6.437-6.436v-2zm-8.285 6.84a8.439 8.439 0 0 1 8.285-6.84v2a6.439 6.439 0 0 0-6.32 5.216l-1.965-.377zM8.89.187a8.439 8.439 0 0 1 8.285 6.84l-1.964.376A6.439 6.439 0 0 0 8.89 2.188v-2zM.453 8.624A8.436 8.436 0 0 1 8.89.188v2a6.436 6.436 0 0 0-6.437 6.436h-2zm0 14.873V8.624h2v14.873h-2zm8.437 8.436a8.436 8.436 0 0 1-8.437-8.436h2a6.436 6.436 0 0 0 6.437 6.436v2zm8.285-6.84a8.439 8.439 0 0 1-8.285 6.84v-2a6.439 6.439 0 0 0 6.32-5.216l1.965.377z",
  fill: "#4E5EFA",
  mask: "url(#cuz305jbda)"
});

function SvgButterflySolid32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButterflySolid32);
export default __webpack_public_path__ + "static/media/butterfly-solid_32.efaffabc.svg";
export { ForwardRef as ReactComponent };